import { useState } from "react";
import axios from "axios";

const FlightSearch = () => {
  const [fromEntityId, setFromEntityId] = useState("");
  const [toEntityId, setToEntityId] = useState("");
  const [yearMonth, setYearMonth] = useState("");
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchPrices = async () => {
    if (!fromEntityId || !toEntityId || !yearMonth) {
      setError("Por favor, preencha todos os campos.");
      return;
    }

    setLoading(true);
    setError("");
    setPrices({});

    const url = `https://sky-scanner3.p.rapidapi.com/flights/price-calendar-web?fromEntityId=${fromEntityId}&toEntityId=${toEntityId}&yearMonth=${yearMonth}&locale=pt-BR&currency=BRL`;
    
    const options = {
      method: "GET",
      headers: {
        "x-rapidapi-key": "da94169e66msh94d246d068679dcp1d2e0bjsn55af6392b289",
        "x-rapidapi-host": "sky-scanner3.p.rapidapi.com",
      },
    };

    try {
      const response = await axios.request(url, options);
      if (response.data?.data?.PriceGrids?.Grid) {
        setPrices(response.data.data.PriceGrids.Grid[0]);
      } else {
        setError("Nenhum preço encontrado.");
      }
    } catch (err) {
      setError("Erro ao buscar preços. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const getDaysInMonth = () => {
    if (!yearMonth) return [];
    const [year, month] = yearMonth.split("-");
    const totalDays = new Date(year, month, 0).getDate();
    return Array.from({ length: totalDays }, (_, i) => i + 1);
  };

  return (
    <div className="container">
      <h2>Buscar Passagens Aéreas</h2>

      <div className="form-group">
        <label>Origem (Código IATA)</label>
        <input
          type="text"
          value={fromEntityId}
          onChange={(e) => setFromEntityId(e.target.value.toUpperCase())}
          placeholder="Ex: BSB"
        />
      </div>

      <div className="form-group">
        <label>Destino (Código IATA)</label>
        <input
          type="text"
          value={toEntityId}
          onChange={(e) => setToEntityId(e.target.value.toUpperCase())}
          placeholder="Ex: MIA"
        />
      </div>

      <div className="form-group">
        <label>Mês de Partida (YYYY-MM)</label>
        <input
          type="month"
          value={yearMonth}
          onChange={(e) => setYearMonth(e.target.value)}
        />
      </div>

      <button onClick={fetchPrices} disabled={loading}>
        {loading ? "Carregando..." : "Buscar Preços"}
      </button>

      {error && <p className="error">{error}</p>}

      {Object.keys(prices).length > 0 && (
        <div className="calendar">
          {getDaysInMonth().map((day, index) => (
            <div key={index} className="calendar-day">
              <p>{day}</p>
              <p className="price">
                {prices[index]?.DirectOutbound?.Price
                  ? `R$ ${prices[index].DirectOutbound.Price.toFixed(2)}`
                  : "N/A"}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Estilização */}
      <style>
        {`
          .container {
            max-width: 600px;
            margin: auto;
            text-align: center;
          }
          .form-group {
            margin-bottom: 10px;
          }
          .form-group input {
            width: 100%;
            padding: 8px;
            margin-top: 5px;
          }
          button {
            padding: 10px 20px;
            background: blue;
            color: white;
            border: none;
            cursor: pointer;
          }
          .calendar {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 10px;
            margin-top: 20px;
          }
          .calendar-day {
            background: #f4f4f4;
            padding: 10px;
            border-radius: 5px;
            text-align: center;
          }
          .price {
            color: green;
            font-weight: bold;
          }
          .error {
            color: red;
            margin-top: 10px;
          }
        `}
      </style>
    </div>
  );
};

export default FlightSearch;
